import LimitsContainer from './LimitsContainer.jsx';
import Select from '../Select';
import TextInput from '../TextInput';
import TextInputWithInlineLabel from '../TextInputWithInlineLabel.jsx';
import TrashIcon from "~/components/icons/TrashIcon";
import {XMarkIcon} from "@heroicons/react/24/outline";

const descriptionMap = {
    none: 'scheduling until fully booked',
    minute: 'a total number of minutes',
    booking: 'a total number of bookings',
};

const periodOptions = {
    daily: 'each day',
    weekly: 'each week',
};

const BusyDescription = ({ limit }) => {
    if (!limit || !limit?.busy) {
        return null;
    }

    return (
        <div>Make me look busy by hiding {limit.busy}% of available times</div>
    );
};

const LimitMaxDescriptionRow = ({limit}) => {
    return (
        <div>
            Allow a max of {limit.count}{' '}
            {limit.type === 'minute' ? 'minutes of bookings' : 'total bookings'}{' '}
            {limit.period === 'weekly' ? 'each week' : 'each day'}
        </div>
    );
}

const LimitDescription = ({ limit }) => {
    if (!limit || limit.type === 'none') {
        return (
            <div>
                Allowing bookings until availability is full
                <BusyDescription limit={limit} />
            </div>
        );
    }

    return (
        <div>
            <LimitMaxDescriptionRow limit={limit} />
            {!!limit?.additional?.length && (
                <div>
                    <span className="text-sm text-gray-500 uppercase">and</span>
                    <LimitMaxDescriptionRow limit={limit?.additional[0]} />
                </div>
            )}
            <BusyDescription limit={limit} />
        </div>
    );
};



const LimitBookingsRow = ({limit, setLimit, className}) => {
    return (
        <div className={className}>
            Allow
            <Select
                options={descriptionMap}
                value={limit?.type}
                onChange={newValue =>
                    setLimit({ ...limit, type: newValue })
                }
                className="inline mx-1"
            />
            {!!limit?.type && limit?.type !== 'none' && (
                <>
                    <TextInput
                        value={limit?.count || ''}
                        type="number"
                        onChange={newValue =>
                            setLimit({ ...limit, count: newValue })
                        }
                        className="inline mx-2"
                        inputClassName="!max-w-16"
                        autoFocus={true}
                    />

                    <Select
                        options={periodOptions}
                        value={limit?.period}
                        onChange={newValue =>
                            setLimit({ ...limit, period: newValue })
                        }
                        className="inline mx-1"
                    />
                </>
            )}
            {limit?.type === 'none' && (
                <>each day</>
            )}
        </div>
    )
}


const LimitInput = ({ limit, setLimit }) => {
    console.log('limit=', limit);
    const isBusyEnabled = limit?.busy > 0 || limit?.busy === '';

    const showAdditionalLimit = !!limit?.additional;
    let addLimitPeriod = '';
    if (limit?.type !== 'none' && !showAdditionalLimit) {
        addLimitPeriod = limit?.period === 'weekly' ? 'daily' : 'weekly';
    }

    return (
        <div>
            <div>
                <LimitBookingsRow
                    limit={limit}
                    setLimit={(newValue) => setLimit({...limit, ...newValue})}
                />

                {!!addLimitPeriod && (
                    <button
                        type="button"
                        className="btn-light-pill-sm uppercase mt-2"
                        onClick={() => {
                            setLimit({
                                ...limit,
                                additional: [
                                    {period: addLimitPeriod}
                                ]
                            })
                        }}
                    >
                        Add {addLimitPeriod} Limit
                    </button>
                )}
                {!!showAdditionalLimit && (
                    <div className="flex items-center justify-between mt-2">
                        <div>
                            <LimitBookingsRow
                                limit={limit.additional[0]}
                                setLimit={(newValue) => {
                                    setLimit({
                                        ...limit,
                                        additional: [
                                            {
                                                ...limit.additional[0],
                                                ...newValue,
                                            }
                                        ]
                                    })
                                }}
                            />
                        </div>
                        <button
                            type="button"
                            className="text-red-600"
                            onClick={() => {
                                setLimit({
                                    ...limit,
                                    additional: null,
                                })
                            }}
                        >
                            <XMarkIcon className="w-4 h-4" />
                        </button>
                    </div>
                )}
            </div>
            <div className="mt-4 flex items-center">
                <label>
                    <input
                        type="checkbox"
                        className="mr-2"
                        checked={isBusyEnabled}
                        onChange={e =>
                            setLimit({
                                ...limit,
                                busy: e.target.checked ? 50 : 0,
                            })
                        }
                    />
                    Make me look busy
                </label>
                {isBusyEnabled && (
                    <div className="ml-1 flex items-center">
                        by hiding
                        <TextInputWithInlineLabel
                            type="number"
                            className="mx-2 w-20"
                            inputClassName="pr-6"
                            value={limit?.busy}
                            onChange={value =>
                                setLimit({ ...limit, busy: value })
                            }
                            opts={{
                                min: 0,
                                max: 100,
                            }}
                            suffix="%"
                        />
                        of time slots
                    </div>
                )}
            </div>
        </div>
    );
};

const LimitsDailyMax = ({ limit }) => {
    return (
        <LimitsContainer
            title="Limit Bookings per Day"
            type="daily"
            limit={limit}
            LimitInput={LimitInput}
            LimitDescription={LimitDescription}
        />
    );
};

export default LimitsDailyMax;
